const faqsEvents = (() => {
    const supportedLocales = [
        'en-US', 'de-DE', 'en-GB', 'fr-FR', 'es-419', 'ja-JP', 'it-IT', 'pt-BR', 'zh-CN'
    ];

    const getLocale = () => {
        const lang = getLanguage();
        return supportedLocales.includes(lang) ? lang : 'en-US';
    };

    const currentPage = window.location.pathname.includes('resume') ? 'resume' : 'home';
    let allFaqs = [];

    const loadFaqs = async () => {
        const locale = getLocale();
        try {
            const res = await fetch(`/dist/custom/js/data/faqs.${locale}.json`);
            allFaqs = await res.json();

            let limit = 10;
            const path = window.location.pathname;

            if (path === '/faqs') {
                limit = 100;
            } else if (path === '/contactus') {
                limit = 4;
            }

            const initialFaqs = allFaqs
                .filter(faq => faq.pages && faq.pages.includes(currentPage))
                .slice(0, limit);

            renderFaqs(initialFaqs);
        } catch (err) {
            console.error(getI18n('faqsFailed'), err);
        }
    };



    const renderFaqs = (faqs) => {
        const container = document.querySelector('.faq-grid');
        if (!container) return;
        container.innerHTML = '';

        faqs.forEach(faq => {
            const firstLetter = faq.username?.[0]?.toUpperCase() || 'U';
            const userAvatar = `
          <svg class="faq-avatar" width="30" height="30" xmlns="http://www.w3.org/2000/svg">
            <circle cx="13" cy="13" r="15" style="fill: var(--avatar-icons-green) !important" />
            <text x="50%" y="50%" text-anchor="middle" dy="4.7px" font-size="14" fill="var(--text-icons)">${firstLetter}</text>
          </svg>
        `;

            const div = document.createElement('div');
            div.className = 'faq-post';
            div.innerHTML = `
          <div class="faq-meta">
            ${userAvatar}
            <span>${faq.username || 'r/ResumeBuilder'} &bull; ${faq.date}</span>
          </div>
          <div class="faq-question">${faq.question}</div>
          <div class="faq-stats">${faq.stats}</div>
          <div class="faq-answer">
            <div class="faq-meta">
              <svg class="faq-answer-avatar" viewBox="0 0 64 64">
                <use href="#avatar-resumebot"></use>
              </svg>
              <span>r/InMinutes &bull; ${faq.date}</span>
            </div>
            <div class="faq-answer-content">${faq.answer}</div>
          </div>
        `;
            container.appendChild(div);
        });
    };

    const filterFaqs = (searchTerm) => {
        const filtered = allFaqs.filter(faq =>
            faq.question.toLowerCase().includes(searchTerm) ||
            faq.answer.toLowerCase().includes(searchTerm)
        );
        renderFaqs(filtered);
    };

    const init = () => {
        const faq_card = document.querySelector('.faq-comments-card');
        if (faq_card) {
            setTimeout(() => {
                faq_card.classList.add('visible');
            }, 50); // delay in ms before showing FAQ card
        }

        loadFaqs();

        const card = document.querySelector('.faq-comments-card');
        if (!card) return;

        const spacer = document.createElement('div');
        spacer.style.height = '10px';

        const input = document.createElement('input');
        input.type = 'search';
        input.id = 'faq-search';
        input.placeholder = getI18n('searchFaqs');
        input.style.cssText = 'width: 100%; padding: 0.5rem; margin: 0 auto 0.1rem auto; display: block; border-radius: 6px; border: 1px solid var(--border-light);';

        card.insertAdjacentElement('afterbegin', input);
        card.insertAdjacentElement('afterbegin', spacer);

        // Only add heading if path is NOT '/faqs'
        if (window.location.pathname !== '/faqs') {
            const heading = document.createElement('h2');
            heading.className = 'faq-header-title';
            heading.textContent = getI18n('faqs');
            card.insertAdjacentElement('afterbegin', heading);
        }

        input.addEventListener('input', (e) => {
            const query = e.target.value.trim().toLowerCase();
            if (query === '') {
                const fallback = allFaqs
                    .filter(faq => faq.pages && faq.pages.includes(currentPage))
                    .slice(0, 10);
                renderFaqs(fallback);
            } else {
                filterFaqs(query);
            }
        });
    };


    return { init };
})();

export default faqsEvents;
